module.exports = __webpack_public_path__ + "img/buenos_aires_chacarita.72ed49ce.jpg";